import './BotaoAdicionar.css';
import { IoAddOutline } from 'react-icons/io5';

const BotaoAdicionar = ({ 
    texto = "Adicionar", 
    aoClicar, 
    className = "" 
}) => {
    return (
      <button className={`botao-adicionar ${className}`} onClick={aoClicar} type="button">
        {texto}
        <span className="icone-adicionar">
          <IoAddOutline />
        </span>
      </button>
    );
};
 
export default BotaoAdicionar;